import React from 'react';

export default function DistortionLayer({ showIndicatrix, showHeatmap, projectionName }) {
  return (
    <section className="gis-panel distortion-panel">
      <h2>Distortion Learning Guide</h2>
      <p>
        Projections exist because Earth is curved and maps are flat. Every projection must distort at least
        one property: shape, area, distance, or direction.
      </p>
      <ul>
        <li>WGS84 is global and interoperable, but not planar-metric.</li>
        <li>Mercator keeps angles and expands high latitudes (Greenland exaggeration).</li>
        <li>SWEREF 99 TM minimizes distortion in Sweden by localizing projection design.</li>
      </ul>
      <div className="legend-row">
        <span className="legend-dot low" />
        <span>Low distortion</span>
        <span className="legend-dot high" />
        <span>High distortion</span>
      </div>
      <p className="hint-text">
        Active projection: <strong>{projectionName}</strong>.
      </p>
      <p className="hint-text">
        Indicatrix: {showIndicatrix ? 'ON' : 'OFF'} | Heatmap: {showHeatmap ? 'ON' : 'OFF'}
      </p>
    </section>
  );
}
